import { colors, Icon, Txt } from '@vst/beam';
import { DownloadOutlined, WhatsappOutlined } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

import { ServiceBenefit } from '../BrazilServiceCard/BrazilServiceCard';

import styles from './ItalyServiceCard.module.scss';

const ItalyServiceCard: React.FC = () => {
  const { t } = useTranslation('Overview');

  const benefits = [
    {
      icon: (
        <div
          className={styles['icon-wrapper']}
          style={{ backgroundColor: colors['gray'][100] }}
        >
          <Icon icon={WhatsappOutlined} color="teal_600" />
        </div>
      ),
      title: t('serviceCardItaly.benefits.whatsApp.title'),
      description: t('serviceCardItaly.benefits.whatsApp.description'),
    },
    {
      icon: (
        <div
          className={styles['icon-wrapper']}
          style={{ backgroundColor: colors['gray'][100] }}
        >
          <Icon icon={DownloadOutlined} color="teal_600" />
        </div>
      ),
      title: t('serviceCardItaly.benefits.downloads.title'),
      description: t('serviceCardItaly.benefits.downloads.description'),
    },
  ];

  return (
    <div>
      <Txt variant="heading5" className={styles['title']}>
        {t('serviceCardItaly.title')}
      </Txt>
      <div className={styles['benefits-list']}>
        {benefits.map((benefit: ServiceBenefit, index) => (
          <ServiceBenefit key={index} benefit={benefit} />
        ))}
      </div>
    </div>
  );
};

export default ItalyServiceCard;
